module.exports = __webpack_public_path__ + "img/circle2.b1282adf.svg";